import { useAuth } from "utilities/auth";
import { useAdminCompany } from "context/AdminCompanyContext";
import { isInternal, isClient } from "utilities/userType";

/**
 * Centralized computation of the effective companyId for API requests.
 *
 * Returns the activeCompanyId (from the company switcher) when the user
 * can switch contexts — either an internal user with sound-admin access,
 * or a parent company client. Falls back to the user's own companyId.
 */
export function useEffectiveCompanyId() {
  const { user } = useAuth();
  const { activeCompanyId, isParentCompany } = useAdminCompany();

  const canSwitch =
    (isInternal(user) && user?.companyId === "sound-admin") ||
    (isClient(user) && isParentCompany);

  return canSwitch ? activeCompanyId || user?.companyId : user?.companyId;
}
